import * as React from "react";
import { useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { SecurityAppSecurityEvents } from "@graylog/enterprise-api";
import SuggestionsList from "components/common/EntityFilters/FilterConfiguration/SuggestionsList";
import useCurrentUser from "hooks/useCurrentUser";
import { fetchOwnerTitles } from "security-app/components/SecurityEvents/Alerts/hooks/useOwnerTitles";
const DEFAULT_SEARCH_PARAMS = {
  query: "",
  pageSize: 10,
  page: 1
};
const fetchAssignedOwners = () => SecurityAppSecurityEvents.getFilterOptions({
  fields: ["owner"],
  timerange: 30 * 86400
}).then((resp) => {
  var _a;
  return fetchOwnerTitles((_a = resp.owner) != null ? _a : []);
}).then((entities) => entities.map((entry) => ({ id: entry.id, value: entry.label })));
const OwnerFilter = ({ attribute, allActiveFilters, filter, filterValueRenderer, onSubmit }) => {
  const [filterQuery, setSearchParams] = useState(DEFAULT_SEARCH_PARAMS);
  const { data: _suggestions, isInitialLoading } = useQuery({
    queryKey: ["security_events", "owners"],
    queryFn: fetchAssignedOwners
  });
  const currentUser = useCurrentUser();
  const suggestions = useMemo(
    () => _suggestions ? [
      { id: null, value: "no owner" },
      { id: currentUser.id, value: `Me (${currentUser.fullName})` },
      ..._suggestions.filter((suggestion) => suggestion.id !== currentUser.id)
    ].filter((suggestion) => suggestion.value.toLowerCase().includes(filterQuery.query.toLowerCase())) : _suggestions,
    [currentUser, _suggestions, filterQuery]
  );
  return /* @__PURE__ */ React.createElement(
    SuggestionsList,
    {
      allActiveFilters,
      attribute,
      multiSelect: !filter,
      filterValueRenderer,
      onSubmit,
      suggestions,
      isLoading: isInitialLoading,
      total: suggestions == null ? void 0 : suggestions.length,
      page: 1,
      pageSize: suggestions == null ? void 0 : suggestions.length,
      setSearchParams
    }
  );
};
export default OwnerFilter;
